import { render, staticRenderFns } from "./modalAsignacionAreasDetalle.vue?vue&type=template&id=7a6289be"
import script from "./modalAsignacionAreasDetalle.vue?vue&type=script&lang=js"
export * from "./modalAsignacionAreasDetalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports